import { Component, inject } from '@angular/core';
import { ChangableComponent } from '@models/changable.component';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-vocabulary-study',
  templateUrl: './vocabulary-study.component.html',
  styleUrls: ['./vocabulary-study.component.scss'],
})
export class VocabularyStudyComponent extends ChangableComponent {
  deviceService = inject(DeviceDetectorService);
}
